// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NaviItem_NavigationItem__Bc2P0"};